import { httpService } from "../common/HttpService";

class LeagueService {

    constructor() { }

    getLeaguesList() {
        return httpService.get("leagues");
    }
   

}

export const leagueService = new LeagueService();